(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8217],{

/***/ 36454:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/email/resend",
      function () {
        return __webpack_require__(3715);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ SkipperTextLogo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_base_elements_SkipperLogo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61278);




function SkipperTextLogo(param) {
    var _href = param.href, href = _href === void 0 ? "/auth/signin" : _href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center cursor-pointer",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_elements_SkipperLogo__WEBPACK_IMPORTED_MODULE_3__/* .SkipperLogo */ .j, {
                    className: "w-12 h-12 fill-current text-teal-600 mr-2 transform scale-110"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "text-4xl text-passport font-bold font-inter",
                    children: "Skipper"
                })
            ]
        })
    });
}


/***/ }),

/***/ 93997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Wave; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function Wave(param) {
    var className = param.className;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute top-32 bottom-0 right-0 left-0 z-0", className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 1440 640",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "none",
        className: classNames,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M473 15.9267C217.959 37.5808 116 31.8926 0 20.7249V640H1440V7.72198C1363 20.7249 915 -21.6011 473 15.9267Z",
            fill: "#e8f6f8",
            fillOpacity: "1"
        })
    });
}


/***/ }),

/***/ 3715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ResendEmail; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34867);
/* harmony import */ var _components_common_svgs_WaveSVG__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93997);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(19602);
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78616);
/* harmony import */ var _graphql_graphql_client_graphClient__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52789);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_common_header_SkipperTextLogo__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98451);
/* harmony import */ var _skipper_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23357);
/* harmony import */ var _components_context_UniversalModalContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47614);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63955);














function ResendEmail() {
    var resendEmail = (0,_graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useResendEmailConfirmationAccountUserMutation */ .dSC)((0,_graphql_graphql_client_graphClient__WEBPACK_IMPORTED_MODULE_6__/* .getClient */ .s3)("users"));
    var dispatchNotification = (0,_components_context_UniversalModalContext__WEBPACK_IMPORTED_MODULE_10__/* .useUniversalModalDispatch */ .Xt)().dispatchNotification;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_11__/* .useForm */ .cI)(), register = ref.register, handleSubmit = ref.handleSubmit, _formState = ref.formState, errors = _formState.errors, isDirty = _formState.isDirty;
    var onSubmit = function(vals) {
        resendEmail.mutateAsync({
            email: vals === null || vals === void 0 ? void 0 : vals.email
        }).then(function(d) {
            var ref;
            var success = d === null || d === void 0 ? void 0 : (ref = d.resendEmailConfirmationAccountUser) === null || ref === void 0 ? void 0 : ref.success;
            if (!!success) {
                router.push("/auth/signin");
                dispatchNotification({
                    title: "Confirmation Email Sent",
                    text: "If your email is registered with Skipper, you should receive confirmation instructions in your inbox. Please check it now",
                    type: "success"
                });
            }
        }).catch(function(e) {
            dispatchNotification({
                title: "Something went wrong",
                text: "Error sending confirmation email",
                type: "danger"
            });
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative flex flex-col sm:block h-screen overflow-y-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_9__/* .TitleAndTags */ .x5, {
                title: "Resend Confirmation Email"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                className: "pt-10 px:1 md:px-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-center justify-between px-1 md:px-20",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_header_SkipperTextLogo__WEBPACK_IMPORTED_MODULE_8__/* .SkipperTextLogo */ .C, {})
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative pt-10 h-full px-2 sm:px-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "z-10",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "retlative md:px-16 py-12 max-w-2xl bg-white rounded-sm z-10 shadow-md border border-gray-100",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                    onSubmit: handleSubmit(onSubmit),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-center font-semibold text-4xl",
                                                children: "Resend Confirmation Email"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-center mt-4 px-2 sm:px-0 whitespace-nowrap",
                                            children: "Did not get confirmation email? Enter your email below and we will resend it"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full mt-4 mb-6 gap-x-6 px-3 sm:px-0",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base__WEBPACK_IMPORTED_MODULE_2__/* .InputGroup */ .BZ, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                                    name: "email",
                                                    id: "account_email_address",
                                                    labelText: "Email address",
                                                    hasError: !!(errors === null || errors === void 0 ? void 0 : errors.email),
                                                    labelClassName: "text-gray-400 font-medium font-inter text-sm"
                                                }, register("email", {
                                                    required: true,
                                                    pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
                                                }))),
                                                !!(errors === null || errors === void 0 ? void 0 : errors.email) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-xs text-red-600 mt-1",
                                                    children: "Valid email is required"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "relative w-full flex justify-center items-center px-24 mt-6",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                                variant: "secondary",
                                                size: "large",
                                                className: "flex w-full rounded-full items-center justify-center pt-4",
                                                shape: "oval",
                                                type: "submit",
                                                disabled: resendEmail.isLoading || !isDirty,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "sm:whitespace-normal whitespace-nowrap text-xl font-inter font-bold py-1",
                                                    children: resendEmail.isLoading ? "Sending Email..." : "Send Confirmation Email"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "group flex items-center justify-center w-full mt-4 cursor-pointer",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                href: "/auth/signin",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    className: "text-magenta-600 font-inter flex items-center",
                                                    children: [
                                                        "Back to log in",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                            className: "-mb-0.5 group-hover:transform group-hover:translate-x-1 w-6 h-6"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative z-20 w-full flex items-center justify-center mt-5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_svgs_WaveSVG__WEBPACK_IMPORTED_MODULE_3__/* .Wave */ .i, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(36454); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);